import { SortOrder } from 'antd/lib/table/interface';
import { SortDivision } from 'shared/enums/substitutions';

export const getOrderDivisionsParams = (
  order?: SortOrder,
): SortDivision.divisionAsc | SortDivision.divisionDesc | undefined =>
  order === 'ascend' ? SortDivision.divisionAsc : order === 'descend' ? SortDivision.divisionDesc : undefined;

export const getOrderSupervisorsParams = (
  order?: SortOrder,
): SortDivision.supervisorAsc | SortDivision.supervisorDesc | undefined =>
  order === 'ascend' ? SortDivision.supervisorAsc : order === 'descend' ? SortDivision.supervisorDesc : undefined;
